import React, { useEffect, useState } from 'react';
import { ContainerDiv } from '../../components/styledComponent/StyledComponent';
import { Col, Row } from '../../components/flexbox/Flex';
import { Card, Label, Tabs } from '@sede-enterprise/shell-ds-react-framework';
import Country from '../../components/country/Country';
import AirportSite from '../../components/airportSite/AirportSite';
import Customers from '../../components/customers/Customers';
import './styles.css'
import AirportCustomers from '../../components/airportCustomers/AirportCustomers';
import MissingDaysConfig from '../../components/missingDaysConfig/MissingDaysConfig';
import { getData } from '../../services/ApiService';
import { ApiUrls } from '../../helpers/ApiUrls';
import ResponseErrorModal from '../../components/responseErrorModal/ResponseErrorModal';
import { usePageTitle } from '../../services/UtilService';
import { APIErrorResponseInterface } from '../../helpers/InterfacesConstants';
import { useTranslation } from 'react-i18next';

interface filter {
    customerDatalst : [];
    countryDatalst : [
        {
            countryName: string;
            countryId: string;
            airports: [
                {
                    airportName: string;
                    airportId: string;
                }
            ]
        }
    ]
}
const MiConfiguration = () => {
    const [filters, setFilters] = useState<filter>();
    const [apiErrorResponse, setApiErrorResponse] = useState<APIErrorResponseInterface | null>();
    const { t } = useTranslation();
    usePageTitle(t('shellAviationAIMS')+" | MI Configuration");
    const getCountriesList = () =>{
        return filters?.countryDatalst;
    }

    const getCustomerList = () => {
        return filters?.customerDatalst;
    }


    const items = [{
        label: <Label bold size='large'>Country</Label>,
        key: 'country',
        children: <Country getcountrylst={getCountriesList}/>
    }, {
        label: <Label bold size='large'>Airport Site</Label>,
        key: 'airportSite',
        children: <AirportSite getcountrylst={getCountriesList}/>,
    }, {
        label: <Label bold size='large'>Customers</Label>,
        key: 'customers',
        children: <Customers getCustomerList={getCustomerList}/>
    }, {
        label: <Label bold size='large'>Airport Customers</Label>,
        key: 'airportCustomers',
        children: <AirportCustomers getCustomerList={getCustomerList} getcountrylst={getCountriesList}/>
    }, {
        label: <Label bold size='large'>Missing Days Config</Label>,
        key: 'missingDaysConfig',
        children: <MissingDaysConfig />
    }];

    
    
    const getCustomersAndCountries = () => {
        const url = ApiUrls.miCustomersAndCountries;
        getData(url).then((response)=>{
            setFilters(response.data);
        }).catch((error)=>{
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        })
    }

    useEffect(() => {
        getCustomersAndCountries();
    },[]);
    return (
        <>
            <ContainerDiv>
                <Row>
					<Col size='100'>
						<h2 style={{margin:'0px'}}>MI Configuration</h2>
					</Col>
                </Row>
            </ContainerDiv>
            <ContainerDiv>
                <Card>
                    <Row>
                        <Col size='100'>
                            <Tabs items={items} defaultActiveKey="A"/>
                        </Col>
                    </Row>
                </Card>
            </ContainerDiv>
            <ResponseErrorModal errorDetails={apiErrorResponse} isOpen={apiErrorResponse ? true : false} onModalClose={()=>{setApiErrorResponse(null)}}></ResponseErrorModal>
        </>
    )
}

export default MiConfiguration;